document
	.querySelectorAll('.block-related-case-study--tabs')
	.forEach((caseStudyBlock) => {
		const tabs = caseStudyBlock.querySelectorAll(
			'.block-related-case-study__tab'
		);
		const resultCards = caseStudyBlock.querySelectorAll('.result-card');

		if (!tabs.length || !resultCards.length) return;

		let currentIndex = 0;
		let autoRotate = true;
		let interval;

		// Function to switch to a tab (and corresponding result card)
		const switchToTab = (index, isManual = false) => {
			tabs.forEach((tab, i) => {
				if (i === index) {
					tab.classList.add('active');
					if (!isManual) {
						tab.classList.add('loading');
					}
				} else {
					tab.classList.remove('active', 'loading');
				}
			});

			resultCards.forEach((card, i) => {
				if (i === index) {
					card.classList.add('active');
				} else {
					card.classList.remove('active');
				}
			});
		};

		// Function to start auto-rotation
		const startAutoRotate = () => {
			interval = setInterval(() => {
				if (!autoRotate) return;

				tabs[currentIndex].classList.remove('loading'); // Remove loading before switching

				currentIndex = (currentIndex + 1) % tabs.length;
				switchToTab(currentIndex);
			}, 5000);
		};

		// Add click event listeners to tabs
		tabs.forEach((tab, index) => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				clearInterval(interval);
				autoRotate = false;

				tabs.forEach((t) => t.classList.remove('loading')); // Remove loading
				switchToTab(index, true);
				currentIndex = index;
			});
		});

		const prevButton = caseStudyBlock.querySelector('.swiper-button-prev');
		const nextButton = caseStudyBlock.querySelector('.swiper-button-next');

		// Add click event listeners for navigation arrows
		if (nextButton) {
			nextButton.addEventListener('click', (e) => {
				e.preventDefault();
				clearInterval(interval);
				autoRotate = false;

				currentIndex = (currentIndex + 1) % tabs.length;
				switchToTab(currentIndex, true);
			});
		}

		if (prevButton) {
			prevButton.addEventListener('click', (e) => {
				e.preventDefault();
				clearInterval(interval);
				autoRotate = false;

				currentIndex = (currentIndex - 1 + tabs.length) % tabs.length;
				switchToTab(currentIndex, true);
			});
		}

		// Initialize first tab as active and loading
		switchToTab(currentIndex);

		// Start auto-rotation
		startAutoRotate();
	});
